import React, { Component } from 'react';
import PropType from 'prop-types';

import { Textarea as WdsTextarea } from '@wds/textarea';

import './textarea.scss';

export class Textarea extends Component {
	constructor(props) {
		super(props);

		const { value, color } = props;
		let characterCount = 0;
		if (value) {
			characterCount = value.length;
		}
		this.state = {
			value: value || '',
			color: color || null,
			currentCharacterCount: characterCount,
		};

		this.countCharacters = this.countCharacters.bind(this);
	}

	countCharacters(event) {
		const { characterLimit } = this.props;
		const { value } = event.target;
		const textareaLength = value.length;

		if (characterLimit !== null && textareaLength <= characterLimit) {
			this.setState({
				value,
				currentCharacterCount: textareaLength,
			});
			// TODO: Remove error state if there is one
		} else if (!characterLimit) {
			this.setState({
				value,
				currentCharacterCount: textareaLength,
			});
		} else {
			// TODO: No change, but add error state if required
			this.setState({
				value: value.substr(0, characterLimit),
				currentCharacterCount: characterLimit,
			});
		}

		// TODO: we should still pass the event, but notify of invalidity
		const { onChange } = this.props;
		if (onChange) {
			// Bubble up to change event
			onChange(event);
		}
	}

	render() {
		const {
			strings,
			characterCount,
			characterLimit,
			onChange,
			stretched,
			...otherProps
		} = this.props;
		const {
			currentCharacterCount,
			value,
			color,
		} = this.state;
		return (
			<div className={stretched ? '' : 'ads-textarea__wrapper'}>
				<WdsTextarea
					{...otherProps}
					stretched={stretched}
					onChange={this.countCharacters}
					value={value}
					color={color}
				/>
				<p
					className={`${(characterLimit && characterCount) ? 'padding-right' : ''} `
						+ 'ads-textarea__subtext wds-type--dark-muted wds-type--body-sm'}
				>
					{
						(characterCount)
						&& (
							<span>
								{`${strings.charactersEntered} ${currentCharacterCount}`}
							</span>
						)
					}
					{
						(characterLimit)
						&& (
							<span>{`${strings.maximum} ${characterLimit}`}</span>
						)
					}
				</p>
			</div>
		);
	}
}

Textarea.propTypes = {
	strings: PropType.shape({
		charactersEntered: PropType.string.isRequired,
		maximum: PropType.string.isRequired,
	}),
	characterCount: PropType.bool,
	characterLimit: PropType.number,
	...WdsTextarea.propTypes,
};

Textarea.defaultProps = {
	...WdsTextarea.defaultProps,
	characterCount: false,
	characterLimit: null,
	strings: {
		charactersEntered: 'Characters entered: ',
		maximum: 'Maximum: ',
	},
};
